export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-path/index.js
// module id = 17
// module chunks = 0